/**
 * all actions for billing state
 *
 * Created by Butterfly on 07/09/18
 */

import C from '../constants'


// action to set billing data
export const setBillingData = objectVal => {
    return {
        type: C.SET_BILLING_DATA,
        payload: objectVal
    }
}


// action to set billing loader
export const showBillingLoader = booleanVal => {
    return {
        type: C.SET_BILLING_LOADER,
        payload: booleanVal
    }
}

// action to set the billing fetch success state
export const setBillingFetchSuccess = booleanVal => {
    return {
        type: C.SET_BILLING_FETCH_SUCCESS,
        payload: booleanVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */

// call the action to fetch billing data
export const getBillingData = () => {
    return {
        type: C.FETCH_BILLING_DATA,
    }
}



// WEBPACK FOOTER //
// ./src/actions/billingActions.js